<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0">{{ hazard.id ? 'Edit' : 'New' }} occupational hazard
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back to occupational hazards list"
              @click="$router.push({ name: 'admin.ocupational-hazard.index' })"
            ><i data-feather="chevron-left" /></a>
            <a
              href="#"
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Senior call settings"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>
      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">

            <div class="card">
              <div class="card-header">
                <h3 class="cart-title">
                  <a data-action="collapse">Content</a>
                </h3>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li>
                      <a data-action="collapse"><i data-feather="chevron-down" /></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-content collapse show">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <div class="mb-1">
                        <label
                          for=""
                          class="form-label"
                        >{{ labels['content.name'] }}</label>
                        <input
                          v-model="hazard.name"
                          type="text"
                          class="form-control"
                        >
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="mb-1">
                        <label
                          for=""
                          class="form-label"
                        >{{ labels['content.host_name'] }}</label>
                        <input
                          v-model="hazard.host_name"
                          type="text"
                          class="form-control"
                        >
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="mb-1">
                        <label
                          for=""
                          class="form-label"
                        >{{ labels['content.description'] }}</label>
                        <quill-editor
                          v-model="hazard.description"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="mb-1">
                        <label
                          for=""
                          class="form-label"
                        >{{ labels['content.host_description_cae'] }}</label>
                        <quill-editor
                          v-model="hazard.host_description"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <InternalNotes
              :notes="hazard.notes"
              @saveNewNote="saveNewNote"
            />

            <AddFile
              :id="9"
              :title="'Documentation'"
              :type="4"
              :visible="false"
              :files="hazard.files"
              @saveAnswer="saveAnswer"
            />

            <RelatedInfo
              v-if="!loading"
              :data="workplaces"
              :title="'workplaces'"
              :selected-data="hazard.workplaces"
              @saveRelatedInfo="saveRelatedInfo"
            />
          </div>
        </div>

        <div class="page-actions">
          <button
            v-if="!sending"
            id="type-success"
            class="btn btn-success"
            @click="save"
          >
            <i data-feather="save" />
            <span class="ms-25 align-middle">Save and Exit</span>
          </button>
          <button
            v-else
            class="btn btn-outline-success"
            type="button"
            disabled=""
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span class="ms-25 align-middle">Saving...</span>
          </button>
        </div>

      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import InternalNotes from '../../partials/components/InternalNotes.vue'
import RelatedInfo from '../../partials/components/RelatedInfo.vue'
import AddFile from '../senior-call/components/AddFile.vue'

export default {
  components: {
    InternalNotes,
    AddFile,
    RelatedInfo,
  },
  data() {
    return {
      hazardId: this.$route.params.id,
      sending: false,
      errors: '',
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      hazard: 'hazards/hazard',
      workplaces: 'workplaces/workplaces',
      labels: 'sectionLabels/itemLabels',
    }),
  },
  async mounted() {
    this.$store.dispatch('sectionLabels/fetchLabels', 'masters.occupational_hazard')
    if (this.hazardId) {
      await this.$store.dispatch('hazards/fetchHazard', this.hazardId)
    } else {
      await this.$store.dispatch('hazards/cleanHazard')
    }
    this.loading = false

    if (!this.hazard.notes) {
      this.hazard.notes = []
    }

    if (this.workplaces.length === 0) {
      await this.$store.dispatch('workplaces/fetch')
    }
  },
  methods: {
    async save() {
      this.sending = true

      try {
        if (this.hazardId) {
          await this.$store.dispatch('hazards/update', { id: this.hazardId, data: this.hazard })
        } else {
          await this.$store.dispatch('hazards/create', this.hazard)
        }
        this.errors = ''
      } catch (e) {
        this.errors = e.response.data.message
      }

      if (this.errors === '' && this.hazard.id) {
        Vue.swal('It has been saved correctly!', '', 'success').then(() => {
          this.$router.push({ name: 'admin.ocupational-hazard.index' })
        })
      } else {
        // Vue.swal
      }

      this.sending = false
    },
    saveNewNote(note) {
      this.hazard.notes.push(note)
    },
    saveRelatedInfo(data) {
      this.hazard.workplaces = data
    },
    saveAnswer(data) {
      this.hazard.files_new = data.data
    },
  },

}
</script>
